<template>
  <div style="width: 100%; overflow-y: auto; overflow-x: hidden; height: 100%">
    <div style="padding: 20px; width: 100%; box-sizing: border-box">
      <el-button
        size="small"
        @click="back"
        icon="el-icon-arrow-left"
        class="back"
        >返回</el-button
      >
      <el-row
        class="mt2"
        type="flex"
        justify="center"
        style="background: #fff; padding: 35px 0 20px 0"
      >
        <el-col :span="8">
          <el-steps
            :active="active"
            process-status="success"
            :align-center="true"
          >
            <el-step title="待提交"></el-step>
            <el-step title="已提交"></el-step>
            <el-step title="订单已审核"></el-step>
            <el-step title="已配车"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form
            ref="form"
            :inline="true"
            label-position="right"
            :model="form"
            :rules="formRules"
            label-width="120px"
          >
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width: 100px">车辆信息</div>
              <div style="display: flex; height: 30px">
                <!-- <el-button size="mini" style="margin-right:10px !important;">订单取消</el-button> -->
                <el-button size="mini" @click="toSave">保存</el-button>
                <!-- <el-button size="mini"
                           style="margin-left:10px !important;">提交</el-button> -->
              </div>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <!-- <el-form-item class="form_item"
                            label="合同编号"
                            prop="contractNo">
                <el-input size="mini"
                          style="width: 160px;"
                          placeholder="请输入"
                          v-model="form.contractNo"></el-input>
              </el-form-item> -->
              <el-form-item class="form_item" label="订单类型" prop="orderType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.orderType"
                >
                  <el-option
                    v-for="item in orderTypeDics"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader
                  size="mini"
                  class="filter-item"
                  style="width: 330px"
                  placeholder="选择订购车型"
                  filterable
                  :show-all-levels="true"
                  :options="carOptions"
                  v-model="form.modelId"
                  @change="changeSpecColor"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="外观颜色"
                prop="modelColor"
              >
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.modelColor"
                  @change="modelColorChange"
                >
                  <el-option
                    v-for="(item, index) in colors"
                    :key="index"
                    :label="item.color + '(' + item.total + ')'"
                    :value="item.color"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carInternalColor"
                  @change="carInternalColorChange"
                >
                  <el-option
                    v-for="(item, index) in carInternalColor"
                    :key="index"
                    :label="item === '' ? '无' : item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.paymentDown"
                ></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.payType"
                >
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker
                  size="mini"
                  style="width: 160px"
                  v-model="form.deliverDate"
                  :picker-options="pickerOptions"
                  :clearable="false"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="form_item" label="订车原因">
                <el-select
                  size="mini"
                  style="width: 200px"
                  placeholder="请选择"
                  v-model="form.orderReason"
                  multiple
                >
                  <el-option
                    v-for="(item, index) in failProductReasonDics"
                    :key="index"
                    :label="item.dataName"
                    :value="item.dataName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="对比车型">
                <el-select
                  size="mini"
                  style="width: 250px"
                  placeholder="请选择"
                  v-model="form.competeSeriesId"
                >
                  <el-option
                    v-for="(item, index) in competitionSeries"
                    :key="index"
                    :label="item.brandName + ' ' + item.seriesName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select
                  size="mini"
                  style="width: 250px"
                  placeholder="请选择"
                  v-model="form.businessType"
                >
                  <el-option 
                    v-for="item in businessTypeOptions" 
                    :key="item.dataValue" 
                    :label="item.dataDisplay"
                    :value="item.dataValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background: #fff; padding: 15px 0">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select
                  size="mini"
                  style="width: 160px"
                  placeholder="请选择"
                  @change="customerTypeChange"
                  v-model="form.customerType"
                >
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                :label="form.customerType === 1 ? '订车人姓名' : '公司名称'"
                prop="customerName"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.customerName"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="联系电话"
                prop="customerPhone"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model="form.customerPhone"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="证件类型"
                prop="identifyType"
              >
                <el-select
                  size="mini"
                  @change="identifyTypeChange"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.identifyType"
                >
                  <el-option
                    v-for="item in orderIdentifyTypeDics"
                    :key="item.dataValue"
                    :label="item.dataDisplay"
                    :value="item.dataValue"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                v-if="form.identifyType === 1"
                label="证件号码"
                prop="identifyNo"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入身份证号码"
                  v-model.trim="form.identifyNo"
                  @input="(e) => { form.identifyNo = e.toUpperCase().replace(/^\s+|\s+$/g, '') }"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                v-if="form.identifyType === 2"
                label="证件号码"
                prop="identifyNo2"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入护照号码"
                  v-model.trim="form.identifyNo2"
                  @input="(e) => { form.identifyNo2 = e.toUpperCase().replace(/^\s+|\s+$/g, '') }"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                v-if="form.identifyType === 3"
                label="证件号码"
                prop="identifyNo3"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入合法军官证件号"
                  v-model.trim="form.identifyNo3"
                  @input="(e) => { form.identifyNo3 = e.toUpperCase().replace(/^\s+|\s+$/g, '') }"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form_item"
                v-if="
                  form.identifyType != 1 &&
                  form.identifyType != 2 &&
                  form.identifyType != 3
                "
                label="证件号码"
                prop="identifyNos"
              >
                <el-input
                  size="mini"
                  style="width: 160px"
                  placeholder="请输入"
                  v-model.trim="form.identifyNos"
                  @input="(e) => { form.identifyNos = e.toUpperCase().replace(/^\s+|\s+$/g, '') }"
                ></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市区">
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择省"
                  clearable
                  @change="provinceChange"
                  v-model="form.customerProvince"
                >
                  <el-option
                    v-for="item in provinces"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择市"
                  clearable
                  @change="cityChange"
                  v-model="form.customerCity"
                >
                  <el-option
                    v-for="item in citys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  size="mini"
                  style="width: 100px"
                  placeholder="选择区"
                  clearable
                  v-model="form.customerCounty"
                >
                  <el-option
                    v-for="item in countys"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="form_item"
                label="详细地址"
                prop="customerAddress"
              >
                <el-input
                  size="mini"
                  style="width: 300px"
                  placeholder="请输入"
                  v-model="form.customerAddress"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px">
              <div class="title">其他信息</div>
              <el-row style="background: #fff; padding: 15px 0">
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item
                  class="form_item"
                  label="下次跟进时间"
                  prop="nextFollowDate"
                >
                  <el-date-picker
                    size="mini"
                    style="width: 160px"
                    :picker-options="pickerOptions"
                    v-model="form.nextFollowDate"
                    :clearable="false"
                    type="date"
                    value-format="timestamp"
                    placeholder="选择日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input
                    type="textarea"
                    style="width: 330px"
                    :rows="2"
                    placeholder="请输入备注内容"
                    v-model="form.remark"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row style="background: #fff; padding: 15px 0">
                <el-col :span="12">
                  <el-form-item
                    class="form_item"
                    label="订车合同/协议(最多三张)"
                    prop="images1"
                  >
                    <Upload v-model="form.images1"></Upload>
                    <!-- <el-upload
                      action
                      accept=".jpeg,.jpg,.png"
                      :limit="3"
                      ref="upload1"
                      :file-list="fileList1"
                      :http-request="uploadRequest1"
                      :on-remove="handleRemove1"
                      :class="{ hide: hideUpload1 }"
                      :on-success="handleUploadSuccess1"
                      :on-change="handleUploadChange1"
                      :before-upload="uploadBefore"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview1(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span
                            class="el-upload-list__item-delete"
                            @click="handleRemove1(file)"
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip">
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload v-model="form.images2"></Upload>
                    <!-- <el-upload
                      action
                      accept=".jpeg,.jpg,.png"
                      :limit="3"
                      ref="upload2"
                      :file-list="fileList2"
                      :http-request="uploadRequest2"
                      :on-remove="handleRemove2"
                      :class="{ hide: hideUpload2 }"
                      :on-success="handleUploadSuccess2"
                      :on-change="handleUploadChange2"
                      :before-upload="uploadBefore"
                      list-type="picture-card"
                    >
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                          alt=""
                        />
                        <span class="el-upload-list__item-actions">
                          <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview2(file)"
                          >
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span
                            class="el-upload-list__item-delete"
                            @click="handleRemove2(file)"
                          >
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip">
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left: 20px">
          <div class="title">订单操作记录</div>
          <el-row style="height: 196px; background: #fff"></el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="submitVisible" width="20%">
      <div class="tips">是否提交管理层进行审批</div>
      <div class="submit-fo">
        <el-button @click="Submit" :loading="subLoading" size="mini"
          >提交审批</el-button
        >
        <el-button
          type="primary"
          :loading="confirmLoading"
          @click="Save"
          size="mini"
          >先保存</el-button
        >
      </div>
      <div class="ps">注：提交审批后，订单信息将不能修改！</div>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="fileList"
      :initialIndex="initialIndex"
    />

    <!-- blc拦截弹窗 -->
    <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
  </div>
</template>

<script>
import ElImageViewer from "./image-viewer";
// import oss from "../../assets/js/ali-oss";
import BlcTips from "@/components/blc-tips/index.vue";
import { modelOptionalsKeyMap } from './constants.js'
import Upload from "@/components/common/Upload.vue";
import { getUrls } from '@/assets/js/util'
var self;
export default {
  components: { ElImageViewer, BlcTips, Upload },
  data() {
    const validateIdentifyNo = (rule, value, callback) => {
      //15位和18位身份证号码的正则表达式
      var regIdCard =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = value.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          }
        }
      } else {
        callback(new Error("请输入合法证件号"));
      }
    };
    const validateReplacedCarNum = (rule, value, callback) => {
      if (this.form.isReplace) {
        var xreg =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
        var creg =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
        if (value.length == 7) {
          if (creg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else if (value.length == 8) {
          if (xreg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else {
          callback(new Error("请输入正确车牌号"));
        }
      }
    };
    const validatePhTelNumber = (rule, value, callback) => {
      const telNumber = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!telNumber.test(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    self = this;
    return {
      modelOptionalsKeyMap,
      showBlcTips: false,
      blcInfo: {},
      initialIndex: 0,
      carInternalColor: [],
      carModelOptionalsMaps: {},
      dealer: this.$common.getLoginInfo().profile,
      customerId: Number(this.$route.query.customerId),
      dealId: this.$route.query.dealId,
      active: 0,
      dialogVisible: false,
      dialogImageUrl: "",
      hideUpload1: false,
      fileList: [],
      fileList1: [],
      hideUpload2: false,
      fileList2: [],
      form: {
        // contractNo: '',
        orderType: "",
        modelId: [],
        modelColor: "",
        // modelVin: '',
        // isSanbao: true,
        paymentDown: "",
        payType: 2,
        // paymentFirst: '',
        // paymentYears: '',
        // paymentDeal: '',
        // paymentOther: '',
        // vehiclePurpose: '',
        // isReplace: false,
        // replacedCarNum: '',
        // isSaledBySecond: false,
        // secondDealerName: '',
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: 1,
        identifyNo: "",
        identifyNos: "",
        identifyNo2: "",
        identifyNo3: "",
        customerAddress: "",
        // address: [],
        deliverDate: "",
        // isReport: true,
        nextFollowDate: "",
        remark: "",
        // mortgagePayment: '',
        images1: [],
        images2: [],
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        carInternalColor: "",
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        orderReason: [],
        competeSeriesId: "",
        businessType: "",
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur"
          }
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur"
          }
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur"
          }
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur"
          }
        ],
        carInternalColor: [
          {
            required: true,
            message: "请选择内饰",
            trigger: "blur"
          }
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur"
          }
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur"
          }
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur"
          }
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur"
          }
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur"
          }
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur"
          }
        ],
        isReplace: [
          {
            required: true,
            message: "请选择是否置换",
            trigger: "blur"
          }
        ],
        replacedCarNum: [
          {
            required: true,
            validator: validateReplacedCarNum,
            trigger: "blur"
          }
        ],
        secondDealerName: [
          {
            required: true,
            message: "请输入二级店名",
            trigger: "blur"
          }
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur"
          }
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur"
          }
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur"
          }
        ],
        identifyNo: [
          {
            required: true,
            validator: validateIdentifyNo,
            trigger: "blur"
          }
        ],
        identifyNos: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur"
          }
        ],
        identifyNo2: [
          {
            required: true,
            message: "请输入护照号码",
            trigger: "blur"
          }
        ],
        identifyNo3: [
          {
            required: true,
            message: "请输入合法军官证件号",
            trigger: "blur"
          }
        ],
        customerPhone: [
          {
            required: true,
            validator: validatePhTelNumber,
            trigger: "blur"
          }
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur"
          }
        ],
        nextFollowDate: [
          {
            required: true,
            message: "请选择下次跟进时间",
            trigger: "blur"
          }
        ],
        images1: [
          {
            required: true,
            message: "请上传合同/协议",
            trigger: "blur"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      orderTypeDics: [], // 订单类型
      orderLoadDurationDics: [], // 按揭期数
      orderVehiclePurposeDics: [], // 车辆用途
      orderIdentifyTypeDics: [], // 证件类型
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      submitVisible: false,
      orderId: "",
      secondDealers: [],
      adressProps: {
        // 省市区信息
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            self.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: self.dealer.dealerId,
                province: "",
                city: ""
              })
              .then(function (res) {
                const provinces = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(provinces);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 1) {
            self.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: self.dealer.dealerId,
                province: node.value,
                city: ""
              })
              .then(function (res) {
                const cities = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(cities);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 2) {
            self.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: self.dealer.dealerId,
                province: node.parent.value,
                city: node.value
              })
              .then(function (res) {
                const countys = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2
                }));
                resolve(countys);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      },
      customers: {},
      additional: {},
      confirmLoading: false,
      subLoading: false,
      provinces: [],
      citys: [],
      countys: [],
      showViewer: false,
      failProductReasonDics: [],
      competitionSeries: [],
      businessTypeOptions: [], // 购车类型
    };
  },
  computed: { 
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key]
          this.form.carModelOptionals[key] = (value[key][0] === '无选装' ? '' : value[key][0])
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderLoadDurationDics = baseInfo.orderLoadDurationDics;
    this.orderVehiclePurposeDics = baseInfo.orderVehiclePurposeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.failProductReasonDics = baseInfo.failProductReasonDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.retrieveCarOptions();
    this.getSecondDealers();
    this.geCustomerInfo();
    this.getProvinces();
    this.getCompetitionSeriesesOptions();
  },
  mounted() {},
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.customerId
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder"
        });
      } else {
        this.$router.go(-1);
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: ""
        })
        .then((res) => {
          this.competitionSeries = res.data.data;
        });
    },
    closeViewer() {
      this.showViewer = false;
    },
    // 省改变
    provinceChange(val) {
      if (val) {
        this.$httpAuth
          .post("/v2/appCustomerService/orderRegion", {
            dealerId: this.dealer.dealerId,
            province: val,
            city: ""
          })
          .then((res) => {
            this.citys = res.data.data;
            this.form.customerCity = "";
            this.form.customerCounty = "";
          });
      } else {
        this.citys = [];
        this.countys = [];
        this.form.customerCity = "";
        this.form.customerCounty = "";
      }
    },
    // 市改变
    cityChange(val) {
      if (val) {
        this.$httpAuth
          .post("/v2/appCustomerService/orderRegion", {
            dealerId: this.dealer.dealerId,
            province: this.form.customerProvince,
            city: val
          })
          .then((res) => {
            this.countys = res.data.data;
            this.form.customerCounty = "";
          });
      } else {
        this.countys = [];
        this.form.customerCounty = "";
      }
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: ""
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    //合同删除
    // handleRemove1(file) {
    //   let fileList1 = this.$refs.upload1.uploadFiles;
    //   let index = fileList1.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList1.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload1 = fileList1.length >= 3;
    //   }, 1000);
    //   this.form.images1.splice(index, 1);
    // },
    // //凭证删除
    // handleRemove2(file) {
    //   let fileList2 = this.$refs.upload2.uploadFiles;
    //   let index = fileList2.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList2.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload2 = fileList2.length >= 3;
    //   }, 1000);
    //   this.form.images2.splice(index, 1);
    // },
    // uploadBefore(file) {
    //   const isLt20M = file.size / 1024 / 1024 < 5;
    //   if (!isLt20M) {
    //     this.$message.error("上传的图片大小不能超过5MB!");
    //     return false;
    //   }
    // },
    //点击预览
    // handlePictureCardPreview1(file) {
    //   this.fileList = this.form.images1.map((item) => item.url);
    //   this.initialIndex = this.form.images1.findIndex(
    //     (item) => item.url == file.url
    //   );
    //   this.showViewer = true;
    // },
    //点击预览
    // handlePictureCardPreview2(file) {
    //   this.fileList = this.form.images2.map((item) => item.url);
    //   this.initialIndex = this.form.images2.findIndex(
    //     (item) => item.url == file.url
    //   );
    //   this.showViewer = true;
    // },
    //合同改变
    // handleUploadChange1(file, fileList) {
    //   this.hideUpload1 = fileList.length >= 3;
    // },
    // //凭证改变
    // handleUploadChange2(file, fileList) {
    //   this.hideUpload2 = fileList.length >= 3;
    // },
    // //合同上传
    // uploadRequest1(option) {
    //   oss.ossUploadFile(option);
    // },
    // //合同上传成功
    // handleUploadSuccess1(res) {
    //   this.form.images1.push({
    //     url: res
    //   });
    // },
    //交易凭证上传
    // uploadRequest2(option) {
    //   oss.ossUploadFile(option);
    // },
    // //交易凭证上传成功
    // handleUploadSuccess2(res) {
    //   this.form.images2.push({
    //     url: res
    //   });
    // },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      var modelId = val[1];
      this.form.modelColor = "";
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.colors = [];
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId
        })
        .then(function (response) {
          that.colors = response.data.data;
        })
        .catch(() => {});
    },
    modelColorChange() {
      this.form.carInternalColor = "";
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelDetail();
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: "",
          carWheel: "",
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carInternalColor = res.data.carInternalColor;
          if(this.carInternalColor && this.carInternalColor[0]) {
            this.form.carInternalColor = this.carInternalColor[0]
            this.getCarModelOptionals()
          }
          const isHasInternalColor = this.carInternalColor.some(Boolean)
          if(!isHasInternalColor) {
            this.getCarModelOptionals()
          }
        });
    },
    carInternalColorChange() {
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelOptionals()
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    toSave() {
      if (this.form.customerAddress != "") {
        if (
          (this.form.customerProvince === "" && this.provinces.length > 0) ||
          (this.form.customerCity === "" && this.citys.length > 0) ||
          (this.form.customerCounty === "" && this.countys.length > 1)
        ) {
          this.$message({
            type: "error",
            message: "订车人省/市/区信息不完整，请选择省/市/区"
          });
          return;
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitVisible = true;
          this.getCarModelSku();
        }
      });
    },
    getCarModelSku() {
      this.$httpAuth
        .post("v2/appVerifyService/getCarModelSku", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor,
          carWheelBoss: "",
          carWheel: "",
          choosePackage: "",
          ...this.form.carModelOptionals
        })
        .then((res) => {
          this.form.skuCode = res.data.skuCode;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    Save() {
      this.confirmLoading = true;
      let params = {
        dealerId: this.dealer.dealerId,
        customerId: Number(this.customerId),
        dealId: Number(this.dealId),
        orderType: this.form.orderType,
        modelId: Number(this.form.modelId[1]),
        modelColor: this.form.modelColor,
        paymentDown: Number(this.form.paymentDown),
        payType: this.form.payType,
        customerType: Number(this.form.customerType),
        customerName:
          Number(this.form.customerType) === 1 ? this.form.customerName : "",
        companyName:
          Number(this.form.customerType) === 2 ? this.form.customerName : "",
        customerPhone: this.form.customerPhone,
        identifyType: this.form.identifyType,
        identifyNo: "",
        customerProvince: this.form.customerProvince,
        customerCity: this.form.customerCity,
        customerCounty: this.form.customerCounty,
        customerAddress: this.form.customerAddress,
        deliverDate: parseInt(this.form.deliverDate / 1000),
        images1: "",
        images2: "",
        nextFollowDate: parseInt(this.form.nextFollowDate / 1000),
        remark: this.form.remark,
        skuCode: this.form.skuCode,
        orderReason: this.form.orderReason.join(","),
        competeSeriesId:
          this.form.competeSeriesId === "" ? 0 : this.form.competeSeriesId,
        businessType: this.form.businessType
      };
      if (this.form.identifyType === 1) {
        params.identifyNo = this.form.identifyNo;
      } else if (this.form.identifyType === 2) {
        params.identifyNo = this.form.identifyNo2;
      } else if (this.form.identifyType === 3) {
        params.identifyNo = this.form.identifyNo3;
      } else {
        params.identifyNo = this.form.identifyNos;
      }
      // let images1 = [];
      // let images2 = [];
      // this.form.images1.forEach((item) => {
      //   images1.push(item.url);
      // });
      // this.form.images2.forEach((item) => {
      //   images2.push(item.url);
      // });
      params.images1 = getUrls(this.form.images1).join(",");
      params.images2 = getUrls(this.form.images2).join(",");
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/createOrder", params)
        .then(function (res) {
          if (res.data.code == 202 && res.data.status== -2) {
            that.confirmLoading = false;
            that.submitVisible = false;
            that.blcInfo = {
              name: params.customerName,
              mobile: params.customerPhone,
              idNo: params.identifyNo,
              detail: res.data.detail
            }
            that.showBlcTips = true;
            return;
          }
          if (res.data.orderId) {
            that.submitVisible = false;
            that.$message({ type: "success", message: "保存成功" });
            that.$router.push({
              path: "/waitingSubmit",
              query: { id: res.data.orderId }
            });
          }
        })
        .catch(() => {
          that.confirmLoading = false;
          that.submitVisible = false;
        });
    },
    Submit() {
      this.subLoading = true;
      let params = {
        dealerId: this.dealer.dealerId,
        customerId: Number(this.customerId),
        dealId: Number(this.dealId),
        orderType: this.form.orderType,
        modelId: Number(this.form.modelId[1]),
        modelColor: this.form.modelColor,
        paymentDown: Number(this.form.paymentDown),
        payType: this.form.payType,
        customerType: this.form.customerType,
        customerName:
          this.form.customerType === 1 ? this.form.customerName : "",
        companyName: this.form.customerType === 2 ? this.form.customerName : "",
        customerPhone: this.form.customerPhone,
        identifyType: this.form.identifyType,
        identifyNo: "",
        customerProvince: this.form.customerProvince,
        customerCity: this.form.customerCity,
        customerCounty: this.form.customerCounty,
        customerAddress: this.form.customerAddress,
        deliverDate: parseInt(this.form.deliverDate / 1000),
        images1: "",
        images2: "",
        nextFollowDate: parseInt(this.form.nextFollowDate / 1000),
        remark: this.form.remark,
        skuCode: this.form.skuCode,
        businessType: this.form.businessType
      };
      if (this.form.identifyType === 1) {
        params.identifyNo = this.form.identifyNo;
      } else if (this.form.identifyType === 2) {
        params.identifyNo = this.form.identifyNo2;
      } else if (this.form.identifyType === 3) {
        params.identifyNo = this.form.identifyNo3;
      } else {
        params.identifyNo = this.form.identifyNos;
      }
      // let images1 = [];
      // let images2 = [];
      // this.form.images1.forEach((item) => {
      //   images1.push(item.url);
      // });
      // this.form.images2.forEach((item) => {
      //   images2.push(item.url);
      // });
      params.images1 = getUrls(this.form.images1).join(",");
      params.images2 = getUrls(this.form.images2).join(",");
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/createOrder", params)
        .then(function (res) {
          if (res.data.code == 202 && res.data.status== -2) {
            that.subLoading = false;
            that.blcInfo = {
              name: params.customerName,
              mobile: params.customerPhone,
              idNo: params.identifyNo,
              detail: res.data.detail
            }
            that.showBlcTips = true;
            that.submitVisible = false;
            return;
          }
          if (res.data.orderId) {
            that.orderId = res.data.orderId;
            that.$httpAuth
              .post("/v2/appCustomerService/submitOrder", {
                dealerId: that.dealer.dealerId,
                orderId: that.orderId
              })
              .then(function (res) {
                that.subLoading = false;
                if (res.data.orderId) {
                  that.submitVisible = false;
                  if (res.data.is_auto_create === 1) {
                    that.$message({ type: "success", message: "提交订单成功，到店登记已自动生成" });
                  } else {
                    that.$message({ type: "success", message: "提交订单成功" });
                  }
                  that.$router.push({
                    path: "/customer/detail/" + that.customerId
                  });
                }
              })
              .catch(() => {
                that.subLoading = false;
              })
              .catch(() => {
                that.submitVisible = false;
              });
          }
        })
        .catch(() => {
          that.subLoading = false;
        });
    },
    // 获取二级店
    getSecondDealers() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderSecondDealers", {
          dealerId: this.dealer.dealerId
        })
        .then(function (res) {
          that.secondDealers = res.data.data;
        })
        .catch(() => {});
    },
    geCustomerInfo() {
      this.$httpAuth
        .post("/v2/appCustomerService/get", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId
        })
        .then((res) => {
          this.customers = { ...res.data.customer };
          this.additional = { ...res.data.additional };
          this.form.customerType = this.customers.type;
          this.form.customerName =
            this.customers.type === 1
              ? this.customers.name
              : this.customers.companyName;
          this.form.customerPhone = this.customers.mobile;
          this.form.businessType = this.customers.businessType || this.businessTypeOptions[0]?.dataValue;
          //   this.form.customerAddress = this.additional.address
          this.form.identifyNo = this.additional.idNo;
          this.form.identifyNo2 = this.additional.idNo;
          this.form.identifyNo3 = this.additional.idNo;
          this.form.identifyNos = this.additional.idNo;
          this.form.identifyType = this.additional.identifyType || 1;
        });
    },
    customerTypeChange(val) {
      if (val === 1) {
        this.form.customerName = this.customers.name;
      } else {
        this.form.customerName = this.customers.companyName;
      }
    },
    identifyTypeChange() {
      this.form.identifyNo = "";
      this.form.identifyNo2 = "";
      this.form.identifyNo3 = "";
      this.form.identifyNos = "";
      this.$nextTick(()=> {
        this.$refs.form.clearValidate('identifyNo')
        this.$refs.form.clearValidate('identifyNo2')
        this.$refs.form.clearValidate('identifyNo3')
        this.$refs.form.clearValidate('identifyNos')
      })
    }
  },
  watch: {}
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.tips {
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.ps {
  width: 100%;
  text-align: center;
  height: 70px;
  font-size: 12px;
  line-height: 40px;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}

.el-image-viewer__btn .el-icon-circle-close {
  color: #fff;
}
</style>
